import React from "react";
import { cn } from "../../../Utils/helper";

const Requirement = ({
  title,
  body,
  className,
  isIneligible = false,
  isEnable,
  showIntroRequirementNotice = false,
  isContentActiveForStyling,
}) => {
  const hasBody = body && (!Array.isArray(body) || body.length > 0);

  if (!hasBody && !showIntroRequirementNotice) {
    return null;
  }

  const borderColor =
    isIneligible || isEnable === false || !isContentActiveForStyling
      ? "border-red-500"
      : "border-blue-300";
  const textColor =
    isIneligible || isEnable === false || !isContentActiveForStyling
      ? "text-[#EF4056]"
      : "text-[#333]";

  if (showIntroRequirementNotice) {
    return (
      <div
        className={cn(
          "relative  border rounded-xl bg-white",
          "border-" + borderColor,
          className
        )}
      >
        {title && (
          <div className="absolute -top-3 left-4 bg-white px-2 py-0.5 rounded">
            <span className="text-base font-bold text-[#333]">{title}</span>
          </div>
        )}
        <div className="p-3">
          <div className="text-base font-medium leading-relaxed flex items-start max-[380px]:text-sm">
            <ul className="list-disc pl-5 text-base font-medium leading-relaxed max-[380px]:text-sm">
              <li className={cn(textColor, "leading-relaxed")}>
                You gotta finish the Introductory Quest first!
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  const bodyArray = Array.isArray(body) ? body : [body];

  return (
    <div
      className={cn(
        "relative  border rounded-xl bg-white",
        "border-" + borderColor,
        className
      )}
    >
      {title && (
        <div className="absolute -top-3 left-4 bg-white px-2 py-0.5 rounded">
          <span className="text-base font-bold text-[#333]">{title}</span>
        </div>
      )}
      <div className="pl-3">
        {bodyArray.map((item, index) => {
          const normalizedItem =
            typeof item === "string" ? item : String(item ?? "");

          if (!normalizedItem.trim()) {
            return null;
          }

          const lines = normalizedItem.split(/\n|\\n/g);

          return (
            <div key={index}>
              <ul className="list-disc pl-5 text-base font-medium leading-relaxed text-[#333] max-[380px]:text-sm">
                {lines.map((line, i) => (
                  <li
                    key={i}
                    className={cn("text-[#333] leading-relaxed", textColor)}
                  >
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Requirement;
